// @flow

import * as React from "react";

import { FeatureFlagsWrapper } from "buba-components";
import LoginView from "buba-components/src/views/Login";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { logIn } from "buba-components/src/api/actions";
import { EMAIL, PASSWORD } from "buba-components/src/views/Login/formFields";
import { mapLoginError } from "buba-components/src/data/statusErrors";
import { getEnvironmentVariable, BANK_INQUIRY_URL } from "buba-components/src/utils/environment";
import { INQUIRY_FORM_LINK } from "buba-components/src/utils/featureFlags";
import type { FeatureFlagsType } from "buba-components/src/utils/featureFlags";
import paths from "../../data/paths";
import { saveUserData as saveUserDataAction } from "../../store/user/actions";

type LoginProps = {
  saveUserData: typeof saveUserDataAction,
  flags: FeatureFlagsType
};

class Login extends React.Component<LoginProps> {
  componentDidMount() {
    const { saveUserData } = this.props;
    try {
      const sessionPersistedUser = sessionStorage.getItem("persist:user");

      if (sessionPersistedUser) {
        const parsedSessionUser = JSON.parse(sessionPersistedUser);
        sessionStorage.removeItem("persist:user");
        const sessionToken = parsedSessionUser.token ? JSON.parse(parsedSessionUser.token) : null;
        const sessionEmail = parsedSessionUser.email ? JSON.parse(parsedSessionUser.email) : null;
        const sessionPasswordExpired = parsedSessionUser.passwordExpired
          ? JSON.parse(parsedSessionUser.passwordExpired)
          : false;

        if (sessionToken) {
          saveUserData(sessionToken, sessionEmail, sessionPasswordExpired);
        }
      }
    } catch (error) {
      console.error("Error processing persist:user from sessionStorage:", error);
    }
  }

  handleSubmit = (values, addMessage, showCredentialError, handleLoginSuccess) => {
    const { saveUserData } = this.props;
    const email: string = values[EMAIL];
    const password: string = values[PASSWORD];

    const onError = error => {
      addMessage(mapLoginError(error.response), "failure");
    };

    return logIn({ email, password, scope: "bank_advisor" })
      .then(response => {
        const {
          data: { access_token: token, password_expired: passwordExpired },
          status
        } = response;

        if (status === 401) {
          showCredentialError();
        } else {
          saveUserData(token, email, passwordExpired);
          handleLoginSuccess();
        }
      })
      .catch(error => onError(error));
  };

  render() {
    const { flags } = this.props;

    return (
      <LoginView
        header="Herzlich Willkommen im Bankpartner-Portal der Bürgschaftsbanken"
        onSubmit={this.handleSubmit}
        resetPasswordPath={paths.resetPassword}
        linkToInquiry={getEnvironmentVariable(BANK_INQUIRY_URL)}
        inquiryFormLink={flags[INQUIRY_FORM_LINK]}
      />
    );
  }
}

export default withRouter(
  connect(null, {
    saveUserData: saveUserDataAction
  })(FeatureFlagsWrapper(Login))
);
